import React from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import {useTranslation} from "../../context/TranslationsProvider";

const AboutMe = () => {

    const { translate } = useTranslation()

    return (
        <div className="flex flex-col min-h-screen bg-[#f4f1ea]">
            <Header />
            <div className="flex-grow flex flex-col items-center pt-14 p-4 sm:p-10">
                <div className="container p-6 sm:p-8 flex flex-col lg:flex-row flex-grow gap-6 sm:gap-12">
                    <div className="flex flex-col w-full lg:w-1/2">
                        <div className="text-gray-800 font-bold">
                            <h1 className="font-semibold lg:text-6xl md:text-4xl text-2xl">Anna</h1>
                            <h1 className="font-semibold lg:text-6xl md:text-4xl text-2xl ml-4">Elvira</h1>
                            <h1 className="font-semibold lg:text-6xl md:text-4xl text-2xl ml-8">Paula</h1>
                        </div>
                        <p className="text-sm text-gray-700 leading-relaxed pl-10 pt-4 sm:pt-6 flex flex-col gap-2 sm:text-left">
                            <span>{translate("about_me_journey")}</span>
                            <span>{translate("about_me_myself")}</span>
                        </p>
                        <div className="mt-auto underline">
                            <a href="https://www.instagram.com/ae.paulart" target="_blank" rel="noopener noreferrer">
                                Instagram
                            </a>
                        </div>
                    </div>
                    <div className="flex justify-center w-full lg:w-1/2">
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/aboutme.jpg'}
                            alt="About Me"
                            className="w-full object-cover"
                        />
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default AboutMe;